import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import StatsStrip from "@/components/StatsStrip";
import ServicesManifesto from "@/components/ServicesManifesto";
import FaqBlock from "@/components/FaqBlock";
import DiagnosticCta from "@/components/DiagnosticCta";
import Seo from "@/components/Seo";
import {
  SegmentSelector,
  AdvantagesStrip,
  LifecycleStrip,
  CaseStudiesTeaser,
} from "@/components/HomeSections";
import { INDUSTRIES } from "@/data/services";
import { HOME_FAQS } from "@/data/faqs";
import {
  organizationSchema,
  websiteSchema,
  professionalServiceSchema,
  faqSchema,
} from "@/lib/schemas";

export default function HomePage() {
  return (
    <div>
      <Seo
        title="Orphion Global HR — The people-function partner for GCCs & AI-native IT"
        description="We build the people function your GCC or AI-native team needs — from first hire to hire-ready, in 90 days. Recruitment, HR operations, HR consulting, employer branding and Fractional CHRO, senior-led with AI-run delivery."
        path="/"
        jsonLd={[
          organizationSchema(),
          websiteSchema(),
          professionalServiceSchema(),
          faqSchema(HOME_FAQS),
        ]}
      />
      <Hero />
      <EditorialMarquee items={INDUSTRIES} speed={28} />
      <SegmentSelector />
      <StatsStrip />
      <AdvantagesStrip />
      <ServicesManifesto />
      <LifecycleStrip />
      <CaseStudiesTeaser />
      <FaqBlock
        kicker="Common questions"
        title={
          <>
            Everything leaders ask{" "}
            <span className="font-serif-accent italic text-[var(--accent)]">
              before
            </span>{" "}
            they engage us.
          </>
        }
        items={HOME_FAQS}
      />
      <DiagnosticCta />
    </div>
  );
}
